import isProduction from '../utils/isProduction';

const backendApi = isProduction
  ? 'https://blog.yanivportfolio.com/api'
  : 'http://localhost:3040/api';
export default backendApi;
